
import {Component} from './base';
import * as moment from 'moment';

export class UpcomingComponent extends Component {
  public static shouldLoad() {
    return $('.upcoming-date').length > 0;
  }

  public load() {
    // Setup the moment locale configuration.
    moment.updateLocale('en', {
      calendar: {
        lastDay : '[Yesterday at] HH:mm',
        sameDay : '[Today at] HH:mm',
        nextDay : '[Tomorrow at] HH:mm',
        lastWeek : '[last] DD-MM-YYYY [at] HH:mm',
        nextWeek : 'DD-MM-YYYY [at] HH:mm',
        sameElse : 'DD-MM-YYYY [at] HH:mm'

      }
    });

    // Replace each dates.
    $('.upcoming-date').each(function() {
      const el = $(this);
      const utc = moment(el.data('utc'));

      let formatted = utc.format('DD-MM-YYYY [at] H:mm');
      if (el.data('niceformatting')) {
        formatted = moment(utc).calendar();
      }

      el.text(formatted);
    });
  }
}



// WEBPACK FOOTER //
// ./~/source-map-loader!./app/Resources/assets/js/components/upcoming.ts